
/** import external dependencies */
import 'jquery-scrollify';
import 'jquery';
import 'bootstrap';



/** import local dependencies */
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import approach from './routes/approach';
import aboutUs from './routes/about';
import portfolio from './routes/portfolio';

/**
 * Populate Router instance with DOM routes
 * @type {Router} routes - An instance of our router
 */
const routes = new Router({
  /** All pages */
  common,
  /** Home page */
  home,
  /** About Us page, note the change from about-us to aboutUs. */
  aboutUs,
  portfolio,
  approach,
});

/** Load Events */
jQuery(document).ready(() => routes.loadEvents());


// Sticky Header
$(window).scroll(function() {
    if ($(this).scrollTop() > 1){
        $('header.new-header').addClass('sticky');
    }
    else {
        $('header.new-header').removeClass('sticky');
    }
});
$( ".fa-search" ).on( "click", function() {
    $('.search-bar').toggleClass('show');
});






// WEBPACK FOOTER //
// ./scripts/main.js